<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='会员配置'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="10">
          <el-button type="primary" @click="showAddDialog">添加配置</el-button>&nbsp;
          <el-select v-model="param.type" placeholder="请选择类型" filterable @change="search">
            <el-option label="请选择类型" :value="0"></el-option>
            <el-option v-for="item in typeList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column prop="title" label="名称" align="center"></el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">
            {{scope.row.type | getTypeTitle(typeList)}}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-arrow-up" size="mini" v-if="param.type > 0 && scope.$index > 0" @click="changePos(scope.row.id, 1)"></el-button>
            <el-button type="primary" icon="el-icon-arrow-down" size="mini" v-if="param.type > 0 && scope.$index < total - 1" @click="changePos(scope.row.id, 2)"></el-button>
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       :current-page="param.page"
       :page-sizes="[10, 20, 30, 40, 50]"
       :page-size="param.count"
       layout="total, sizes, prev, pager, next, jumper"
       :total="total">
     </el-pagination>
    </el-card>
    <user-config-add
      :visible="addDialogAvaible"
      :id="currentId"
      :typeList="typeList"
      @add="add"
      @update="update"
      @closeDialog="closeAddDialog">
    </user-config-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import UserConfigAdd from './UserConfigAdd.vue'
export default {
  name: 'user_config_list',
  components: {
    'bread-crumb': BreadCrumb,
    'user-config-add': UserConfigAdd
  },
  created () {
    this.getTypeList()
    this.getList()
  },
  data () {
    return {
      currentId: 0,
      list: [],
      typeList: [],
      addDialogAvaible: false,
      total: 0,
      pageTotal: 1,
      param: {
        type: 0,
        page: 1,
        count: 10
      }
    }
  },
  filters: {
    getTypeTitle (id, typeList) {
      for (var i = 0; i < typeList.length; i++) {
        if (id === typeList[i].id) {
          return typeList[i].title
        }
      }
      return ''
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/user_config/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async getTypeList () {
      const res = await this.$http.get('/admin/user_config/type_list')
      if (res.code === 0) {
        this.typeList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getList()
    },
    async changePos (id, changeType) {
      const res = await this.$http.post('/admin/user_config/change_pos', {
        id: id,
        pos: changeType
      })
      if (res.code === 0) {
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async add (data) {
      const res = await this.$http.post('/admin/user_config/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async update (id, data) {
      const res = await this.$http.post('/admin/user_config/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/user_config/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 70px;
}
</style>
